export default __webpack_public_path__ + "static/media/reward-tiers2.3d1bfd58.webp";